import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/TopBar";
import { Outlet } from "react-router-dom";

export default function AppLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  // Close drawer whenever the route changes (mobile nav item tap).
  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Sidebar open={drawerOpen} onClose={() => setDrawerOpen(false)} />

      {/* Mobile backdrop */}
      {drawerOpen && (
        <button
          type="button"
          data-testid="mobile-drawer-backdrop"
          aria-label="Close menu"
          onClick={() => setDrawerOpen(false)}
          className="lg:hidden fixed inset-0 z-30 bg-black/40 backdrop-blur-sm"
        />
      )}

      <div className="lg:ml-64 min-h-screen flex flex-col">
        <TopBar onMenu={() => setDrawerOpen(true)} />
        <main data-testid="app-main" className="flex-1">
          <div className="max-w-[1400px] mx-auto p-4 sm:p-6 lg:p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
